import React from "react";
import styles from "./style.module.scss";

export function ConsolePageHeaderActionSecondary({
  className,
  children,
  ...props
}) {
  return (
    <button
      type="button"
      className={`${styles.actionSecondary} console-header-action-secondary ${
        className || ""
      }`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}

export function ConsolePageHeaderActionOverflow({
  className,
  children,
  ...props
}) {
  return (
    <button
      type="button"
      className={`${styles.actionOverflow} console-header-action-overflow ${
        className || ""
      }`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}

export function ConsolePageHeaderActionPrimary({
  className,
  children,
  ...props
}) {
  return (
    <button
      type="button"
      className={`${styles.actionPrimary} console-header-action-primary ${
        className || ""
      }`.trim()}
      {...props}
    >
      {children}
    </button>
  );
}

export default function ConsolePageHeader({
  title,
  titleColor,
  breadcrumb,
  actions,
  className,
}) {
  return (
    <div className={`${styles.header} ${className || ""}`.trim()}>
      <div className={styles.titleGroup}>
        <h5
          className={styles.title}
          style={titleColor ? { color: titleColor } : undefined}
        >
          {title}
        </h5>
        {breadcrumb ? (
          <>
            <span
              className={styles.divider}
              style={titleColor ? { color: titleColor } : undefined}
            >
              /
            </span>
            <div className={styles.breadcrumbSelect}>{breadcrumb}</div>
          </>
        ) : null}
      </div>
      {actions ? (
        <div className={`${styles.actions} console-page-header-actions`}>
          {actions}
        </div>
      ) : null}
    </div>
  );
}

export { styles as consolePageHeaderStyles };
